import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  init: () => {
    const sections = document.querySelectorAll("[data-scale-back]");

    sections.forEach((section) => {
      const pin = section.dataset.pin || true;
      const parent = section.parentElement;
      const nextElement = parent.nextElementSibling;
      const img = section.querySelector("img");
      const video = section.querySelector("video");
      const scaleBackAmount = section.dataset.scaleBackAmount || 0.3;

      ScrollTrigger.create({
        trigger: section,
        start: "bottom bottom",
        end: nextElement ? `top top` : "bottom top",
        endTrigger: nextElement,
        pin: pin,
        pinSpacing: false,
        onEnter: () => {
          if (img) {
            gsap.to(img, {
              borderRadius: "50px",
              duration: 0.5,
              overwrite: true,
            });
          }

          if (video) {
            gsap.to(video, {
              borderRadius: window.innerWidth > 768 ? "50px" : "32px",
              duration: 0.5,
              overwrite: true,
            });
          }
        },
        onUpdate: (self) => {
          const progress = self.progress;
          gsap.to(section, {
            scale: 1 - progress * scaleBackAmount,
            transformOrigin: "top left",
            duration: 0.1,
            overwrite: true,
          });
        },
        onLeaveBack: () => {
          if (img) {
            gsap.to(img, {
              borderRadius: "0",
              duration: 0.5,
              overwrite: true,
            });
          }

          if (video) {
            gsap.to(video, {
              borderRadius: "0",
              duration: 0.5,
              overwrite: true,
            });
          }
        },
      });
    });
  }
}
